import React, {useState, Fragment} from 'react';
import styles from  './sustainability-index.module.scss';
import { dataConvertOverview } from '../../utils/convert';
import { sustIndexOverview } from "../../data/data-sustainability-index";
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';
import CheckboxDialog from '../common/checkboxDialog/checkbox-dialog';
import TextToolTip from '../common/textTooltip/TextToolTip';


const options = [
    {label:"Wealth tier*", value:"tier"},
    {label:"Wealth per capita (USD)*", value:"wealth"},
    {label:"2023 Sustainable Development Goal Index score**", value:"devGoal"},
    {label:"Population density (people/km²)***", value:"population"},
    {label:"CO₂ emissions per capita (%)***", value:"co2"},
];


const groupOptions = [
  {label:"Investment migration options", value:"im"},
  {label:"G7", value:"g7"},
  {label:"BRICS+6", value:"brics"},

];

const groupOptionList = groupOptions.map(i => i.value);

const SustainabilityIndex = () =>{
    const [sortColumn, setSortColumn] = useState("wealth");
    const [wealthCount, setWealthCount] = useState(1);
    const [devGoalCount, setDevGoalCount] = useState(1);
    const [populationCount, setPopulationCount] = useState(1);
    const [co2Count, setCO2Count] = useState(1);
    const [tierCount, setTierCount] = useState(1);
    const level = ['Very low', 'Low', 'Middle', 'Middle-high', 'High', 'Very high']
    
    const [selectedGroupOption, setSelectedGroupOption] = useState(groupOptionList);
    const [numOfCitiesShow, setNumOfCitiesShow] = useState(10);
    const [hideList, setHideList] = useState(true);

    const dataSustIndexOverview = () => {
      return dataConvertOverview(sustIndexOverview);
    }
    
    
    const handleOptionSelect = (option) => {
        setSortColumn(option.value);
    };
    

    const handleSort = (columnName) => {
      switch (columnName) {

        case 'wealth':
          (wealthCount === 1) ? setWealthCount(-1) : setWealthCount(1);
          break;
        case 'devGoal':
          (devGoalCount === 1) ? setDevGoalCount(-1) : setDevGoalCount(1);
          break;
        case 'population':
          (populationCount === 1) ? setPopulationCount(-1) : setPopulationCount(1);
          break;
        case 'co2':
          (co2Count === 1) ? setCO2Count(-1) : setCO2Count(1);
          break;
        case 'tier':
          (tierCount === 1) ? setTierCount(-1) : setTierCount(1);
          break;
        default:
          break;
      }
  
      setSortColumn(columnName);
  
    };
  
    const reverseSortNum = (data, columnName, count) => {
      if (count === 1) {
        return data.sort((a, b) => b[columnName] - a[columnName] || a['country'].localeCompare(b['country']) );
      }
      return data.sort((a, b) => a[columnName] - b[columnName] || a['country'].localeCompare(b['country']) );
    }
    
  
    const handleSortingOptions = (data, columnName) => {
      switch (columnName) {
        case 'wealth':
          return reverseSortNum(data, columnName, wealthCount);
        case 'devGoal':
          return reverseSortNum(data, columnName, devGoalCount);
        case 'population':
          return reverseSortNum(data, columnName, populationCount);
        case 'co2':
          return reverseSortNum(data, columnName, co2Count);
        case 'tier':
          return (tierCount === 1) ?
            data.sort((a, b) => level.indexOf(b[columnName]) - level.indexOf(a[columnName]) ||  a['country'].localeCompare(b['country']))
            : data.sort((a, b) => level.indexOf(a[columnName]) - level.indexOf(b[columnName]) ||  a['country'].localeCompare(b['country']));

        default:
          break;
      }
      
    }
        
    const handleFilterFunction = (functionOption) => {
      return (selectedGroupOption !== functionOption) ? setSelectedGroupOption(functionOption) : "";
    };
    
    const handleFilterColumn = (columnName) => {
      const copyOfGroupList = [...selectedGroupOption];
      (copyOfGroupList.includes(columnName)) ? copyOfGroupList.splice(copyOfGroupList.indexOf(columnName), 1) : copyOfGroupList.push(columnName);
      return (selectedGroupOption.length === 1 && selectedGroupOption.includes(columnName)) ? '' : handleFilterFunction(copyOfGroupList);
      
    };
    

    
    
    const groupSortList = (l) => {
      return selectedGroupOption.map((g) => l[g] === 'TRUE').some(Boolean);
    }
    
    const nonRelatedGroupLogo = (l) => {
      const notSelectedGroupOption = groupOptionList.filter((i) => !selectedGroupOption.includes(i));
      notSelectedGroupOption.forEach((g) => l[g] = '');
      return l;
    }    
    
    const handleGroupSort = (sortColumn) => {
      let data = handleSortingOptions(dataSustIndexOverview(), sortColumn);
      let selectedData = data.filter((a) => groupSortList(a));
      
      return (JSON.stringify(selectedGroupOption.sort()) === JSON.stringify(groupOptionList.sort())) ?
        data
        : selectedData.map((a) => nonRelatedGroupLogo(a));
    };
    
    // const oldHandleGroupSort = () => {
    //   let groupData = [];

    //   if (JSON.stringify(selectedGroupOption.sort()) === JSON.stringify(groupOptionList.sort())) {
    //     return handleSortingOptions(dataSustIndexOverview(), sortColumn);
    //   }
      
    //   selectedGroupOption.forEach((i) => {
    //     let selectedData = [];
    //     // if (selectedGroupOption.includes('brics')) {
    //     if (i === 'brics') {
    //       selectedData = dataSustIndexOverview().filter((a) => a['brics'] === 'TRUE');
    //       selectedData.map((a) => a['g7'] = '');          
    //       selectedData.map((a) => a['im'] = '');
    //     }
    //     // if (selectedGroupOption.includes('g7')) {
    //     if (i === 'g7') {
    //       selectedData = dataSustIndexOverview().filter((a) => a['g7'] === 'TRUE');
    //       selectedData.map((a) => a['brics'] = '');
    //       selectedData.map((a) => a['im'] = '');
    //     }
    //     // if (selectedGroupOption.includes('im')) {
    //     if (i === 'im') {
    //       selectedData = dataSustIndexOverview().filter((a) => a['im'] === 'TRUE');
    //       selectedData.map((a) => a['brics'] = '');
    //       selectedData.map((a) => a['g7'] = '');

    //     }
    //     selectedData = handleSortingOptions(selectedData, sortColumn)
    //     groupData = groupData.concat(selectedData);
    //   })
      
    //   return groupData;
    //   // return (JSON.stringify(selectedGroupOption.sort()) === JSON.stringify(groupOptionList.sort())) ?
    //   //   dataSustIndexOverview()
    //   //   : groupSortList();
    // };
    
    
    
    const sortedData = sortColumn
      ? handleGroupSort(sortColumn)
      : dataSustIndexOverview();
      
      
      
    const handleShowHideList = () => {
      setHideList(!hideList);
      setNumOfCitiesShow(numOfCitiesShow === 10 ? `${sortedData.length}` : 10);
    };


    return( 
        <>  
            
            {/* <h2 className="mb-5">Wealth and Sustainability Table</h2> */}
            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect} />

                <CheckboxDialog onClick={handleFilterFunction} groupOptions={groupOptions}/>
    
            </div>
            <table className={`chartTable ${styles.sustainabilityChartTable}`}>
                <thead>
                    {/* <tr>
                      <th className={`${styles.cellHideMobile} ${styles.placeholderCells}`}><></></th>
                      <th className={`${styles.cellHideMobile} ${styles.placeholderCells}`}><></></th>
                      <th className={`${styles.cellHideMobile} ${styles.placeholderCells}`}><></></th>
                      <th className={`${styles.cellHideMobile} ${styles.placeholderCells}`}><></></th>
                      <th className={`${styles.cellHideMobile} ${styles.placeholderCells}`}><></></th>
                      <th className={`${styles.cellHideMobile} ${styles.placeholderCells}`}><></></th>
                      <th 
                        className={`text-center ${styles.cellHideMobile} ${styles.placeholderCells}`}
                        colSpan="3" >
                        <div className={`${styles.cellHideMobile}`}>
                          <CheckboxDialog onClick={handleFilterFunction} groupOptions={groupOptions}/>
                        </div>
                      </th>
                    </tr> */}
                    <tr>
                        <th className={styles.countryColumn}>Country</th>
                          <th className={`d-md-none text-center ${styles.groupColumn} `} >
                                <span className={styles.sortColumnTitleText}>IM
                                  <br/>
                                  <div className={`${styles.groupLogo} ${styles.imLogo} ${selectedGroupOption.includes('im') ? '' : styles.unselectedLogo } `}></div>
                                </span>
                          </th>
                          <th className={`d-md-none text-center  ${styles.groupColumn} `}>
                                <span className={styles.sortColumnTitleText}>G7
                                  <br/>
                                  <div className={`${styles.groupLogo} ${styles.g7Logo} ${selectedGroupOption.includes('g7') ? '' : styles.unselectedLogo } `}></div>
                                </span>
                          </th>
                          <th className={`d-md-none text-center  ${styles.groupColumn}  ${styles.bricsColumn} `}>
                                <span className={styles.sortColumnTitleText}>BRICS+6
                                  <br/>
                                  <div className={`${styles.groupLogo} ${styles.bricsLogo} ${selectedGroupOption.includes('brics') ? '' : styles.unselectedLogo } `}></div>
                                </span>
                          </th>
                          
                          <th
                              className={`text-left ${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'tier'? styles.selectedColumn: ''}`}
                              onClick={() => handleSort("tier")}
                          >
                              <div className={styles.sortColumnTitle}>
                                  <span className={styles.sortColumnTitleText}>Wealth tier<sup>∗</sup></span>
                                  {(tierCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                          </th>
                          <th 
                              className={`text-left ${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'wealth'? styles.selectedColumn: ''}`}
                              onClick={() => handleSort("wealth")}
                          >
                              <div className={styles.sortColumnTitle}>
                                  <span className={styles.sortColumnTitleText}>Wealth per capita<br/>(USD)<sup>∗</sup></span>
                                  {(wealthCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                          </th>      
                          <th 
                              className={`text-left ${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'devGoal'? styles.selectedColumn: ''}`}
                              onClick={() => handleSort("devGoal")}
                          >
                              <div className={styles.sortColumnTitle}>
                                  <span className={styles.sortColumnTitleText}>2023 Sustainable <br/>Development Goal <br/>Index score<sup>∗∗</sup></span>
                                  {(wealthCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                          </th>   
                          <th
                              className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'population'? styles.selectedColumn: ''}`}
                              onClick={() => handleSort("population")}
                          >
                              <div className={styles.sortColumnTitle}>
                                  <span className={styles.sortColumnTitleText}>Population <br/>density <br/>(people/km²)<sup>∗∗∗</sup></span>
                                  {(populationCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                          </th>
                          <th
                              className={
                                  `text-left
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${sortColumn === 'co2'? styles.selectedColumn: ''}`}
                              onClick={() => handleSort("co2")}
                          >
                              <div className={styles.sortColumnTitle}>
                                  <span className={styles.sortColumnTitleText}>CO₂ emissions <br/>per capita (%)<sup>∗∗∗</sup></span>
                                  {(co2Count === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                          </th>
                          
                          <th className={`text-center ${styles.cellHideMobile} ${styles.groupColumn}  `} 
                                onClick={() => handleFilterColumn("im")}>
                                <span className={styles.sortColumnTitleText}>
                                  <TextToolTip frontText="IM" insideText="Investment migration offering"/>
                                  <br/>
                                  <div className={`${styles.groupLogo} ${styles.imLogo}  ${selectedGroupOption.includes('im') ? '' : styles.unselectedLogo } `}></div>
                                </span>
                          </th>
                          <th className={`text-center ${styles.cellHideMobile} ${styles.groupColumn} `} 
                                onClick={() => handleFilterColumn("g7")}>
                                <span className={styles.sortColumnTitleText}>
                                  <TextToolTip frontText="G7" insideText="Group of 7 advanced economies"/>
                                  <br/>
                                  <div className={`${styles.groupLogo} ${styles.g7Logo}  ${selectedGroupOption.includes('g7') ? '' : styles.unselectedLogo } `}></div>
                                </span>
                          </th>
                          <th className={`text-center ${styles.cellHideMobile} ${styles.groupColumn} ${styles.bricsColumn} `} 
                                onClick={() => handleFilterColumn("brics")}>
                                <span className={styles.sortColumnTitleText}>
                                  <TextToolTip frontText="BRICS+6" insideText="Bloc of emerging market economies"/>
                                  <br/>
                                  <div className={`${styles.groupLogo} ${styles.bricsLogo}  ${selectedGroupOption.includes('brics') ? '' : styles.unselectedLogo } `}></div>
                                </span>
                          </th>

                          
                    </tr>
                </thead>
                <tbody>
                    {sortedData.slice(0, numOfCitiesShow).map((item, index) => (
                    // {sortedData.map((item, index) => (
                        <Fragment key={index}>
                            <tr className={`${styles.contentRow}`}>
                                <td>
                                    <CountryFlag country={item.country} />
                                </td>
                                
                                {/* <div className={`d-md-none`}> */}
                                  <td className={`d-md-none text-center `}>
                                    {item.im && <div className={`${styles.groupLogo} ${styles.imLogo}`}></div>}
                                  </td>
                                  <td className={`d-md-none text-center `}>
                                    {item.g7 && <div className={`${styles.groupLogo} ${styles.g7Logo}`}></div>}
                                  </td>
                                  <td className={`d-md-none text-center ${styles.borderRight}`}>
                                    {item.brics && <div className={`${styles.groupLogo} ${styles.bricsLogo} `}></div> }
                                  </td>
                                {/* </div> */}
                                
                                <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'tier'? styles.selectedColumn: ''}`}>{item.tier}</td>
                                <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'wealth'? styles.selectedColumn: ''}`}>{formatNumberWithDot(item.wealth)}</td> 
                                <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'devGoal'? styles.selectedColumn: ''}`}>{formatNumberWithDot(item.devGoal)}</td>
                                <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'population'? styles.selectedColumn: ''}`}>{formatNumberWithDot(item.population)}</td>
                                <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'co2'? styles.selectedColumn: ''}`}>{formatNumberWithDot(item.co2) + '%'}</td>                                
                                <td className={`text-center ${styles.cellHideMobile} ${styles.logoCellsHolder} `}>
                                  {item.im && <div className={`${styles.groupLogo} ${styles.imLogo}`}></div>}
                                </td>
                                <td className={`text-center ${styles.cellHideMobile} ${styles.logoCellsHolder} `}>
                                  {item.g7 && <div className={`${styles.groupLogo} ${styles.g7Logo}`}></div>}
                                </td>
                                <td className={`text-center ${styles.cellHideMobile} ${styles.logoCellsHolder} `}>
                                  {item.brics && <div className={`${styles.groupLogo} ${styles.bricsLogo}`}></div> }
                                </td>


                            </tr>
                           
                        </Fragment>
                    ))}
                </tbody>
            </table>
            
            <div className={styles.showButton} >
              <button className={styles.collapseButton} onClick={handleShowHideList}>
                {/* {hideList ? `Show All ${sortedData.length} Cities` : "Collapse list"} */}
                {hideList ? `Show All Countries` : "Collapse list"}
              </button>
            </div>
            
            {selectedGroupOption.length === 0 ? <div className={styles.cellHideMobile} style={{height: "120px"}}></div> : ""}
            <div className="footer-note mt-5">
              <ul>
                {/* <li>Wealth tiers: Very high – wealth per capita over USD 300,000; High – USD 50,000 to USD 300,000; Middle-high – USD 30,000 to USD 50,000; Middle – USD 10,000 to USD 30, und000; Low – USD 3,000 to USD 10,000; Very low –  under USD 3,000</li> */}
                <li>Wealth per capita: Figures for June 2023, rounded to nearest 100.</li>
                <li>2023 Sustainable Development Goal Index scores: <a href="https://doi.org/10.25546/102924">doi.org/10.25546/102924</a></li>
                <li>Population density: Figures for 2021 (latest available)<a href="https://data.worldbank.org/indicator/EN.POP.DNST">data.worldbank.org/indicator/EN.POP.DNST</a></li>
                <li>CO₂ emissions per capita: Calculated using two variables, CO₂ emissions (kt) divided by population. CO₂ data for 2020 (latest available)  <a href="https://data.worldbank.org/indicator/EN.ATM.CO2E.KT">data.worldbank.org/indicator/EN.ATM.CO2E.KT</a> and  <a href="https://data.worldbank.org/indicator/SP.POP.TOTL">data.worldbank.org/indicator/SP.POP.TOTL</a></li>
              </ul>
              <p>Sources: <sup>∗</sup>New World Wealth; <sup>∗∗</sup>Sachs, J.D., Lafortune, G., Fuller, G., Drumm, E. (2023). Implementing the SDG Stimulus. Sustainable Development Report 2023. Dublin: Dublin University Press, 2023; <sup>∗∗∗</sup>World Bank</p>
            </div>
        </>
    )
}

export default SustainabilityIndex;
